
import { SelectOption } from '@/models/generics'
import {defineComponent, PropType, reactive, toRefs, watch} from 'vue'

export default defineComponent({
  name: 'MultiSwitch',
  props: {
    modelValue: {
      type: [String, Number],
      required: true,
    },
    options: {
      type: Array as PropType<SelectOption<string | number>[]>,
      required: true,
    },
    disable: {
      type: Array as PropType<Array<string>>
    },
    readonly: {
      type: Boolean
    }
  },
  emits: ['update:model-value'],
  setup (props, { emit }) {
    const state = reactive<{ toggleValue: string | number | null, filteredOptions: Array<SelectOption<string | number>>}>({
      toggleValue: props.options.find(opt => opt.value === props.modelValue)?.value ??
                   props.options[0]?.value ?? null,
      filteredOptions: !props.disable?.length ? props.options : props.options.map(o => ({...o, disabled: props.disable?.includes(o.label)}))
    })
    watch(
      () => props.modelValue,
      (newValue) => state.toggleValue !== newValue && (state.toggleValue = props.modelValue)
    )
    watch(
      () => state.toggleValue,
      (newValue) => props.modelValue !== newValue && emit('update:model-value', newValue)
    )

    return {
      ...toRefs(state)
    }
  }
})
